import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { ChangePassword } from './model';
import { noDefault } from 'lib/eventWrappers';
import { PCModal } from 'portcall/pcmodal/view';
import { ValidationErrorView } from 'core/validationerror/view';

export const ChangePasswordView = SuperCritical(({ modelContainer } : { modelContainer : () => ChangePassword | null }) =>
    <PCModal className="changepassword" shown={() => !!modelContainer()} onBackDropClick={modelContainer()?.HidePopup}>
        <div className="modal-content">
            <div className="modal-header">
                {(m => m &&
                    <button className="close" onClick={m.HidePopup}>
                        <span aria-hidden="true">&times;</span>
                        <span className="sr-only">Close</span>
                    </button>
                )(modelContainer())}
                <h2 className="modal-title">Change password</h2>
            </div>
            {(m => m &&
                <div className="modal-body">
                    {!m.Success() ?
                        <form onSubmit={noDefault(m.Submit)}>
                            <div className="form-group">
                                <input type="password" className="form-control pc-input-box"
                                    placeholder="Old password"
                                    value={m.ChangePasswordRequest.OldPassword()}
                                    onChange={e => m.ChangePasswordRequest.OldPassword((e.target as HTMLInputElement).value)} />
                                <ValidationErrorView error={() => m.Validation()['OldPassword']} />
                            </div>
                            <div className="form-group">
                                <input type="password" className="form-control pc-input-box"
                                    placeholder="New password"
                                    value={m.ChangePasswordRequest.NewPassword()}
                                    onChange={e => m.ChangePasswordRequest.NewPassword((e.target as HTMLInputElement).value)} />
                                <ValidationErrorView error={() => m.Validation()['NewPassword']} />
                            </div>
                            <div className="form-group">
                                <input type="password" className="form-control pc-input-box"
                                    placeholder="Confirm password"
                                    value={m.ChangePasswordRequest.ConfirmPassword() || ''}
                                    onChange={e => m.ChangePasswordRequest.ConfirmPassword((e.target as HTMLInputElement).value)} />
                                <ValidationErrorView error={() => m.Validation()['ConfirmPassword']} />
                            </div>
                            <div className="form-group pc-button-shell">
                                <button type="submit" className="pc-button pc-button-primary">Change</button>
                            </div>
                        </form>
                        :
                        <div>
                            <div>
                                Your password has been changed successfully.
                            </div>
                            <div>
                                <button className="pc-button pc-button-primary" onClick={m.HidePopup}>OK</button>
                            </div>
                        </div>
                    }
                    <div className="clearfix"></div>
                </div>
            )(modelContainer())}
        </div>
    </PCModal>
);


// WEBPACK FOOTER //
// ./apps/core/changepassword/view.tsx